










export default

	props:
		item: Object
		contentMap: Object
		full: Boolean

	computed:
		flavored: ->
			if @contentMap?.flavored then return true
			else return false

		shouldShow: ->
			if @flavored && @item?.title == "Harvest Year" then return false
			else return true

		widthClasses: -> [
			'full' if @full
		]

